import { ComponentClass, FunctionComponent, memo, ReactNode, useMemo } from "react";
import { AuthorizationContext, AuthorizationContextValue } from "./context";

export type AuthorizationContextProviderProps = {
  isAuthorizing?: boolean,
  isSuperAdmin?: boolean,
  permissions?: string[],
  redirectUrl?: string,
  superAdminPermission?: string,
  accessDeniedStub?: ReactNode | FunctionComponent<any> | ComponentClass<any>
  children: ReactNode | ReactNode[]
}

export const AuthorizationContextProvider = memo<AuthorizationContextProviderProps>((
  {
    isAuthorizing,
    isSuperAdmin,
    permissions,
    redirectUrl,
    superAdminPermission,
    accessDeniedStub,
    children,
  }) => {

  const authorizationContextValue = useMemo((): AuthorizationContextValue => {
    const allPermissions = permissions || [];
    return ({
      isAuthorizing: isAuthorizing || false,
      isSuperAdmin: isSuperAdmin || (superAdminPermission && allPermissions.some(x => x === superAdminPermission)) || false,
      permissions: allPermissions,
      redirectUrl: redirectUrl || "/",
      accessDeniedStub,
    });
  }, [ isAuthorizing, isSuperAdmin, permissions, redirectUrl, superAdminPermission, accessDeniedStub ]);

  return (
    <AuthorizationContext.Provider value={authorizationContextValue}>
      {children}
    </AuthorizationContext.Provider>
  );
});

export default AuthorizationContextProvider;
